"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CollapseIcon = function CollapseIcon(_ref) {
  var className = _ref.className;
  return _react.default.createElement("svg", {
    className: (className || '') + '',
    height: "9",
    viewBox: "0 0 16 9",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M15.2734 8.97656L8 1.71094L0.726563 8.97656L0.0234375 8.27344L8 0.289062L15.9766 8.27344L15.2734 8.97656Z"
  }));
};

CollapseIcon.defaultProps = {
  className: undefined
};
CollapseIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = CollapseIcon;
exports.default = _default;